import React from 'react'
import { AthletesList } from 'pages'

export const AthleteListActive = (): JSX.Element => {
	return <AthletesList status statusGroup="active" />
}
